import styled from 'styled-components'

import Icon from '../Icon'

export const Social = styled(Icon)``
